import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Image from 'react-bootstrap/Image'
import img from '../../img/IMG-20211119-WA0025-01-01.jpeg'
import './About.css'


const About = () => {
    return (
        <>
            <hr />
                <Container fluid="md sm sx" className='bg mb-5'>
            <Row className='g-0 justify-content-md-center'>
                <Col sm={12} lg={5} xs={12} md={6} className='me-5 mt'>
                    <div class="polaroid ">
                        <Image src={img} className="img1" width='350px' />
                        {/* <p>Image 1<br />more Text ...</p> */}
                    </div>
                </Col>
                <Col sm={12} lg={6} xs={12} md={6} className='ms-3'>
                   <div className="col2">
                        <h1 className=' text-center in-left'>About Me</h1>
                        <hr className="style text-center" />
                        <p>Hi, I’m Rezuana <br />
                            Currently I'm a student of East Delta University Chittagong and I'm pursuing my BSc in computer science and engineering. Throughout my entire life, I’ve always been interested in Web development. I always loved playing around with code and learning new things. But it wasn’t until that high school where I first had my first class about it that really made me fall in love with the subject.
                            I have experience in HTML, CSS, and JavaScript. I gained experience coding responsive websites. Many of my projects were developing websites using React and React-Bootstrap. I also have worked on some projects using Material UI and Tailwind.
                            <br />
                            Let’s be friends?</p>
                        <div class="d-flex flex-column align-items-center">
                            <h4 class="mb-4 bold text-danger">LET'S CONNECT</h4>
                            <section>
                                <div class="wrapper">

                                    <a href="https://www.linkedin.com/in/rezuana-haque-42150418b/">
                                        <div class="button">
                                            <div class="icon">
                                                <i class="fab fa-linkedin-in color"></i>
                                            </div>
                                            <span>LinkedIn</span>
                                        </div>
                                    </a>
                                    <a href="https://github.com/RezuanaHaque">
                                        <div class="button">
                                            <div class="icon">
                                                <i class="fab fa-github color"></i>
                                            </div>
                                            <span>Github</span>
                                        </div>
                                    </a>
                                    <a href="https://www.instagram.com/_m__e__g__h__a_/">
                                        <div class="button">
                                            <div class="icon">
                                                <i class="fab fa-instagram color"></i>
                                            </div>
                                            <span>Instagram</span>
                                        </div>
                                    </a>

                                    <a href="https://www.facebook.com/rezuanahaque.megha">
                                        <div class="button">
                                            <div class="icon">
                                                <i class="fab fa-facebook-f color"></i>
                                            </div>
                                            <span>Facebook</span>
                                        </div>
                                    </a>
                                        <a href="https://medium.com/@Rezuana_Haque">
                                            <div class="button">
                                                <div class="icon">
                                                    <i class="fab  color fa-brands fa-medium"></i>
                                                </div>
                                                <span>Medium</span>
                                            </div>
                                        </a>
                                        
                                    {/* <div class="button">
                                        <div class="icon">
                                            <i class="fab fa-twitter"></i>
                                        </div>
                                        <span>Twitter</span>
                                    </div> */}


                                    {/* <div class="button">
                                        <div class="icon">
                                            <i class="fab fa-youtube"></i>
                                        </div>
                                        <span>YouTube</span>
                                    </div> */}

                                </div>
                            </section>
                        </div>
                   </div>
                </Col>
            </Row>
        </Container>
            <hr />
        </>

    );
};

export default About;